import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useBoolean,
} from "@chakra-ui/react";

import { JsonForm, JsonFormControl } from "@components";
import { useAuth } from "@hooks";

const LoginFormControl: JsonFormControl[] = [
  {
    label: "Email",
    inputType: "email",
    fieldName: "email",
    defaultValue: "",
    autocomplete: "username",
    placeholder: "example@university.edu",
    config: {
      required: "Email is required",
      pattern: {
        value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
        message: "Make sure this is a valid Email",
      },
    },
  },
  {
    label: "Password",
    inputType: "password",
    fieldName: "password",
    defaultValue: "",
    autocomplete: "current-password",
    config: {
      required: "Passwords are required to login",
    },
  },
];

function Login() {
  const navigate = useNavigate();
  const { user, login } = useAuth();
  const [error, setError] = React.useState<string>("");
  const [isLoggingIn, { on: loginStart, off: loginEnd }] = useBoolean(false);

  React.useEffect(() => {
    if (user) window.history.back();
  }, [navigate, user]);

  const doLogin = React.useCallback(
    async ({ email, password }: { email: string; password: string }) => {
      try {
        loginStart();
        setError("");
        const user = await login(email, password);
        if (!user) throw new Error("Incorret email or password.");
      } catch (ex) {
        setError("Incorrect Email or Password.");
      } finally {
        loginEnd();
      }
    },
    [loginStart, loginEnd, setError, login],
  );

  return (
    <Card width="450px">
      <CardHeader>
        <Heading>Login</Heading>
      </CardHeader>
      <CardBody>
        <JsonForm
          fields={LoginFormControl}
          onSubmit={doLogin}
          isLoading={isLoggingIn}
          submitButtonText="Login"
        />
        {error && (
          <Alert status="error" marginTop="16px">
            <AlertIcon />
            <AlertTitle>{error}</AlertTitle>
          </Alert>
        )}
      </CardBody>
    </Card>
  );
}

export { Login };
